(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-native"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-native"], factory);
	else if(typeof exports === 'object')
		exports["JSONSchemaForm"] = factory(require("react"), require("react-native"));
	else
		root["JSONSchemaForm"] = factory(root["React"], root["react-native"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__18__) {
return 